"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ellipsis = void 0;
var _button = _interopRequireDefault(require("@clayui/button"));
var _core = require("@clayui/core");
var _shared = require("@clayui/shared");
var _react = _interopRequireDefault(require("react"));
var _excluded = ["alignmentPosition", "disabled", "disabledPages", "hrefConstructor", "items", "onPageChange"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var Item = _core.__EXPERIMENTAL_MENU.Item,
  Menu = _core.__EXPERIMENTAL_MENU.Menu;
var Ellipsis = exports.Ellipsis = function Ellipsis(_ref) {
  var _alignmentPosition = _ref.alignmentPosition,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$disabledPages = _ref.disabledPages,
    disabledPages = _ref$disabledPages === void 0 ? [] : _ref$disabledPages,
    hrefConstructor = _ref.hrefConstructor,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    onPageChange = _ref.onPageChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var ariaLabel = otherProps['aria-label'] && !disabled ? (0, _shared.sub)(otherProps['aria-label'], [String(items[0]), String(items[items.length - 1])]) : undefined;
  var title = otherProps['title'] && !disabled ? (0, _shared.sub)(otherProps['title'], [String(items[0]), String(items[items.length - 1])]) : undefined;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "page-item"
  }, /*#__PURE__*/_react.default.createElement(Menu, {
    disabled: disabled,
    items: items,
    trigger: /*#__PURE__*/_react.default.createElement(_button.default, _extends({}, otherProps, {
      "aria-label": ariaLabel,
      className: "page-link",
      displayType: "unstyled",
      title: title
    }), "...")
  }, function (item) {
    return /*#__PURE__*/_react.default.createElement(Item, {
      disabled: disabledPages.includes(item),
      href: hrefConstructor ? hrefConstructor(item) : undefined,
      key: item,
      onClick: function onClick() {
        return onPageChange && onPageChange(item);
      }
    }, String(item));
  }));
};